module.exports = __webpack_public_path__ + "img/2.33da7bbb.png";